import DOMPurify from 'dompurify';

const SANITIZE_PROFILES = {
    rich: {
        USE_PROFILES: { html: true },
        ALLOW_DATA_ATTR: false,
        FORBID_TAGS: ['script', 'style'],
    },
    inline: {
        ALLOWED_TAGS: ['b', 'strong', 'i', 'em', 'code', 'span', 'br'],
        ALLOWED_ATTR: ['class'],
        ALLOW_DATA_ATTR: false,
        FORBID_TAGS: ['script', 'style'],
    },
};

export const sanitizeHtml = (dirtyHtml, profile = 'rich', options = {}) => {
    if (typeof dirtyHtml !== 'string') {
        return '';
    }

    const profileOptions = SANITIZE_PROFILES[profile] || SANITIZE_PROFILES.rich;
    return DOMPurify.sanitize(dirtyHtml, {
        ...profileOptions,
        ...options,
    });
};

export { SANITIZE_PROFILES };
